import { Component, computed, input } from '@angular/core';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { isMonthsAgo } from '@app/helpers/date';
import { TextsPipe } from '@app/pipes/texts.pipe';

@Component({
  selector: 'mobi-is-new',
  imports: [MobiUiIconComponent, TextsPipe],
  templateUrl: './is-new.component.html',
  styleUrl: './is-new.component.scss',
})
export class IsNewComponent {
  readonly date = input.required<string>();
  isNew = computed(() => isMonthsAgo(this.date(), 4));
}
